import ChangeIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
// import ApproveIcon from '@material-ui/icons/ThumbUp';
import { useMutateForm } from 'api/useMutateForm';
import * as React from "react";
import { Button, useListContext, useRedirect, useTranslate } from 'react-admin';
import { utcToZonedTime } from 'date-fns-tz';
// import { OrderState } from 'entities/OrderState';
// import { isExternalNotApproved } from 'utils/checker/entity';
// import { UserRole } from 'entities';

const MultipleOrdersEditButton = ({ selectedIds = null, basePath }) => {
	const translate = useTranslate();
	const redirect = useRedirect();

	const label = translate('resources.orders.bulk-edit.button');

	const handleOnClick = () => {
		const query = `selected_ids=${selectedIds.join(',')}`;
		const redirectTo = `${basePath}/multiple-changes?${query}`;
		redirect(redirectTo);
	};

	return (
		<Button
			onClick={handleOnClick}
			label={label}
		>
			<ChangeIcon />
		</Button>
	);
};


const MultipleOrdersDeleteButton = ({ selectedIds = [], basePath, resource }) => {
	const translate = useTranslate();
	const [mutateForm, _] = useMutateForm("updateManyPartialArray", resource, basePath, selectedIds, {}); // eslint-disable-line

	const label = translate('resources.draft-orders.bulk-delete.button');

	const handleOnClick = () => {
		const data = { deleted_at: utcToZonedTime(new Date(), 'UTC') };
		mutateForm(data, "list");
		window.location.reload();
	};

	return (
		<Button
			onClick={handleOnClick}
			label={label}
		>
			<DeleteIcon color="error" />
		</Button>
	);
};


// const MultipleOrdersApproveButton = ({ selectedIds = [], basePath, resource }) => {
// 	const translate = useTranslate();
// 	const [mutateForm, _] = useMutateForm("updateManyPartialArray", resource, basePath, selectedIds, {}); // eslint-disable-line

// 	const label = translate('resources.external-not-approved-draft-orders.bulk-approve.button');

// 	const handleOnClick = () => {
// 		const data = { state: OrderState.is_external_approved };
// 		mutateForm(data, "list");
// 		window.location.reload();
// 	};

// 	return (
// 		<Button
// 			onClick={handleOnClick}
// 			label={label}
// 		>
// 			<ApproveIcon color="action" />
// 		</Button>
// 	);
// };


const CustomBulkActionButtons = ({ isDraft, isOSFCUser }) => {
	const { basePath, resource, selectedIds } = useListContext();
	const sharedProps = { selectedIds, basePath };

	// const filteredDataBySelected = React.useMemo(() => (
	// 	Object.values(data)
	// 	.filter(rec => selectedIds.indexOf(rec.id) !== -1)
	// ), [data, selectedIds]);

	// const isAllExternalNotApproved = filteredDataBySelected
	// 	.every(rec => isExternalNotApproved(rec.state));

	// const isAllExternalApprovedOrNone = filteredDataBySelected
	// 	.every(rec => !isExternalNotApproved(rec.state));

	if (selectedIds.length == 0) return null;

	return (
		<React.Fragment>
			{isOSFCUser ? <MultipleOrdersEditButton {...sharedProps} /> : null}
			{/* {isDraft && isAllExternalNotApproved ? <MultipleOrdersApproveButton {...sharedProps} resource={resource} /> : null} */}
			{isDraft ? <MultipleOrdersDeleteButton {...sharedProps} resource={resource} /> : null}
		</React.Fragment>
	);

};


export default CustomBulkActionButtons;
